import type { CreateGasStationDto, GasStationResponseDto } from "@pro-sto/api-client";

export type GasStationStatus = CreateGasStationDto["status"];

/** Поля админ-оверрайда — пока не в OpenAPI, ожидаются на бэкенде */
export type GasStationWithAdminOverride = GasStationResponseDto & {
  admin_override?: boolean;
};

export type UpdateGasStationWithAdminOverride = {
  clear_admin_override?: boolean;
};

export type FuelPriceKey =
  | "price_gas"
  | "price_dt"
  | "price_ai_92"
  | "price_ai_95"
  | "price_ai_95_plus"
  | "price_ai_98"
  | "price_ai_100";

export interface FuelTypeConfig {
  key: FuelPriceKey;
  label: string;
}

export const FUEL_TYPES: FuelTypeConfig[] = [
  { key: "price_gas", label: "Газ" },
  { key: "price_dt", label: "ДТ" },
  { key: "price_ai_92", label: "АИ-92" },
  { key: "price_ai_95", label: "АИ-95" },
  { key: "price_ai_95_plus", label: "АИ-95+" },
  { key: "price_ai_98", label: "АИ-98" },
  { key: "price_ai_100", label: "АИ-100" },
];

export const STATUS_OPTIONS: Array<{
  value: NonNullable<GasStationStatus>;
  label: string;
}> = [
  { value: "yes", label: "В наличии" },
  { value: "queue", label: "Очередь" },
  { value: "low", label: "Мало" },
  { value: "no", label: "Нет" },
];

export const DEFAULT_MAP_CENTER = { lat: 59.9343, lon: 30.3351 };
export const DEFAULT_MAP_ZOOM = 11;

export const STATUS_MARKER_COLORS: Record<
  NonNullable<GasStationStatus>,
  string
> = {
  yes: "#0AB878",
  queue: "#CC8D18",
  low: "#D97706",
  no: "#E83046",
};

export function parseGasStationField(value: unknown): string {
  if (value == null) return "";
  if (typeof value === "string") return value;
  return String(value);
}

export function getStatusLabel(status: NonNullable<GasStationStatus>): string {
  return STATUS_OPTIONS.find((option) => option.value === status)?.label ?? status;
}
